// ============================================================================================
// Sportal ad wrapper - build 28082026
//
// Change in this build: Taboola added as a header bidding partner.
//   - One {bidder: 'taboola'} entry appended to the bids of all 57 Prebid ad units
//     (ATF and BTF, desktop and mobile). publisherId 2085250, tagId 100008802_<AdUnitCode>_<size>.
//     The size suffix in the tagId is Taboola-internal reporting only; it does not limit served sizes.
//   - pbjs.bidderSettings.taboola added: storageAllowed + 0.75 gross-to-net bidCpmAdjustment.
//   - Requires the Prebid 11.8.0 library rebuilt with taboolaBidAdapter (sportal-prebid11.8.0-2.js in
//     this same folder; "-2" = new cache key, same Prebid version inside). Wrapper and library must be deployed / rolled back together.
// Nothing else changed: layout, sizes, refresh, timeouts, floors and all other bidders are as in 13072026.
// ============================================================================================

// Reference to the global command queue for asynchronous execution of GPT-related calls.
// Define this before any startup logic so early DOM-ready start cannot race the queue setup.
window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];
var googletag = window.googletag;

// Reference to the global command queue for asynchronous execution of Prebid-related calls.
// Prebid is still best-effort only; GAM serving must never wait on optional ID modules.
window.pbjs = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];
var pbjs = window.pbjs;

// Start the wrapper as soon as DOM is ready, without waiting for full window.load.
// Critical safety rule: do not call runWrapper() until GPT API is actually available.
// This avoids the race where googletag.cmd exists but googletag.pubads() is not ready yet.
function startWrapperOnce(reason) {
    if (window.prebidAuctionRun || window.__sportalWrapperStartPending) {
        return;
    }

    window.__sportalWrapperStartPending = true;
    clearTimeout(window.adsLoadTimer);
    waitForGptAndRunWrapper(reason, 0);
}

function waitForGptAndRunWrapper(reason, attempt) {
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];
    googletag = window.googletag;

    if (window.prebidAuctionRun) {
        window.__sportalWrapperStartPending = false;
        return;
    }

    if (typeof googletag.pubads === 'function' && typeof googletag.defineSlot === 'function') {
        window.prebidAuctionRun = true;
        window.__sportalWrapperStartPending = false;

        try {
            runWrapper();
        } catch (e) {
            // Do not retry in a loop. Surface the error for debugging, but avoid duplicate auctions.
            if (window.console && typeof window.console.error === 'function') {
                window.console.error('Sportal ad wrapper failed to start:', reason, e);
            }
        }
        return;
    }

    // GPT is normally fast, but it can load asynchronously. Poll briefly instead of touching pubads too early.
    if (attempt < 240) { // 240 * 50ms = 12s max wait for GPT API
        setTimeout(function() {
            waitForGptAndRunWrapper(reason, attempt + 1);
        }, 50);
        return;
    }

    window.__sportalWrapperStartPending = false;

    if (window.console && typeof window.console.error === 'function') {
        window.console.error('Sportal ad wrapper did not start: GPT API was not ready after 12s', reason, {
            googletagExists: !!window.googletag,
            cmdIsArray: Array.isArray(window.googletag && window.googletag.cmd),
            pubadsType: typeof (window.googletag && window.googletag.pubads),
            apiReady: window.googletag && window.googletag.apiReady,
            pubadsReady: window.googletag && window.googletag.pubadsReady
        });
    }
}

function scheduleWrapperStart(reason) {
    window.adsLoadTimer = setTimeout(function() {
        startWrapperOnce(reason);
    }, 0);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        scheduleWrapperStart('domcontentloaded');
    }, { once: true });
} else {
    scheduleWrapperStart('dom_ready');
}

// Safety fallback only. In normal cases the wrapper starts on DOM ready above.
window.addEventListener('load', function() {
    startWrapperOnce('window_load_fallback');
});

// ID5 for secure signals sharing in GAM
window.ID5EspConfig = { 
    partnerId: 1355 // ID5 partnerId
};

// Amount of time (ms) that Prebid allows the bidders to respond to ad requests.
var PREBID_TIMEOUT = 1500;

// Shared header bidding floor configuration. Requires Prebid priceFloors module.
var HB_BID_FLOOR = 0.06;
var HB_BID_FLOOR_CURRENCY = 'EUR';
var HB_FLOORS_CONFIG = {
    currency: HB_BID_FLOOR_CURRENCY,
    schema: {
        fields: ['mediaType', 'size']
    },
    values: {
        'banner|*': HB_BID_FLOOR
    },
    default: HB_BID_FLOOR
};

// Number of seconds to wait after the slot becomes viewable.
// Sticky gets a faster refresh cadence; all other refreshable slots keep the current 30s cadence.
var DEFAULT_SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
var STICKY_SECONDS_TO_WAIT_AFTER_VIEWABILITY = 20;
var BILLBOARD_SECONDS_TO_WAIT_AFTER_VIEWABILITY = 20;
var SECONDS_TO_WAIT_AFTER_VIEWABILITY = DEFAULT_SECONDS_TO_WAIT_AFTER_VIEWABILITY;

// Advertisers for which refresh shouldn't apply. Just add the company IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ADVERTISER_IDS = [];

// Campaigns for which refresh shouldn't apply. Just add the order IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ORDER_IDS = [];

// Adhesion / Sticky line items for which refresh shouldn't apply.
// Use this to protect specific Sticky line items from being refreshed away,
// without blocking refresh for the same line item on other slots.
var GAM_NOREFRESH_ADHESION_LINE_ITEM_IDS = [];

// Ad units (div ids) for which refresh shouldn't apply. Just add the div IDs e.g ['Branding_Left', 'Branding_Right'].
var GAM_NOREFRESH_ADUNITS = ['Sidebar_HP'];

// How far should the ad be for the lazy loading to activate.
var DISTANCE_IN_PIXELS_FOR_LAZY_LOADING = "350px";

// How much (in percent) should the ad slot be viewable. 
var VISIBILITY_PERCENT_FOR_REFRESH = 0.7;

// Variables for all defined slots. 
var Adhesion;
var Billboard_HP;
var Sidebar_HP;
var Billboard_Desktop;
var Billboard_Mobile;
var P1_Desktop;
var P1_Mobile;
var P2_Desktop;
var P2_Mobile;
var P3_Desktop;
var P3_Mobile;
var P4_Desktop;
var P4_Mobile;
var P5_Desktop;
var P5_Mobile;
var P6_Desktop;
var P6_Mobile;
var P7_Desktop;
var P7_Mobile;
var P8_Desktop;
var P8_Mobile;
var P9_Desktop;
var P9_Mobile;
var P10_Desktop;
var P10_Mobile;
var In_Text_1_Desktop;
var In_Text_1_Mobile
var In_Text_2_Desktop;
var In_Text_2_Mobile;
var In_Text_3_Desktop;
var In_Text_3_Mobile;
var In_Text_4_Desktop;
var In_Text_4_Mobile;
var In_Text_5_Desktop;
var In_Text_5_Mobile;
var In_Text_6_Desktop;
var In_Text_6_Mobile;
var In_Text_7_Desktop;
var In_Text_7_Mobile;
var In_Text_8_Desktop;
var In_Text_8_Mobile;
var In_Text_9_Desktop;
var In_Text_9_Mobile;
var In_Text_10_Desktop;
var In_Text_10_Mobile;
var Under_Article_Desktop;
var Under_Article_Mobile;
var In_Gallery_1_Desktop;
var In_Gallery_1_Mobile;
var In_Gallery_2_Desktop;
var In_Gallery_2_Mobile;
var In_Gallery_3_Desktop;
var In_Gallery_3_Mobile;
var In_Gallery_4_Desktop;
var In_Gallery_4_Mobile;
var In_Gallery_5_Desktop;
var In_Gallery_5_Mobile;

// Top level ad unit path. 
var adUnitPath = "/161634325/Sportal.rs/";

var adWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

// ATF and BTF array variables. 
var adUnitsATF = [];
var adUnitsBTF = [];
function runWrapper() {

    //console.log('Ad Wrapper: Script execution.');

    var adContainers = document.querySelectorAll('.wrapperAd'); // Find all divs which have wrapperAd class.

    googletag.cmd.push(function() { // Push the defined ad units to the GPT array.

        // Sticky GPT size mapping. 
        var sticky_mapping = googletag.sizeMapping()
        .addSize([1600, 0], [[728, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [1, 1]]) //desktop for bigger screens
        .addSize([1024, 0], [[728, 90], [750, 100], [1, 1]]) //desktop for smaller screens
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50], [1, 1]]) //tablet
        .addSize([0, 0], [[300, 50], [320, 50], [300, 100], [320, 100], [1, 1]]) //mobile
        .build();

        // Billboard_HP GPT size mapping.
        var billboardHP_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [970, 66], [950, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [980, 120], [930, 180], [970, 250], [980, 240], [980, 250], [990, 250], [1060, 250], [1240, 250]]) //desktop
        .addSize([469, 0], [[728, 90]]) //tablet
        .addSize([0, 0], []) //mobile
        .build();   

        // Sidebar_HP GPT size mapping.
        var sidebarHP_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[300, 250], [120, 600], [160, 600], [300, 600]]) //desktop
        .addSize([469, 0], []) //tablet
        .addSize([0, 0], []) //mobile
        .build();

        // Billboard GPT size mapping.
        var billboard_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [970, 66], [950, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [980, 120], [930, 180], [970, 250], [980, 240], [980, 250], [990, 250], [1060, 250]]) //desktop
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50]]) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100]]) //mobile
        .build();   

        // Custom size mappings for P ad units. 
        var custom_p1_mapping = [];
        var custom_p2_mapping = [];
        var custom_p3_mapping = [];

        if (typeof adsKeywords.pageType != 'undefined' && adsKeywords.pageType.includes("landingPageVideo")) {
            var custom_p1_mapping = [[200, 200], [250, 250], [300, 250]];
        }

        else {
            var custom_p1_mapping = [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]];
        }

        if (typeof adsKeywords.pageType != 'undefined' && ((adsKeywords.pageType.includes("competitionHub") && adsKeywords.pageType.includes("overview")) || (adsKeywords.pageType.includes("teamHub") && adsKeywords.pageType.includes("overview")))) {
            var custom_p2_mapping = [[200, 200], [250, 250], [300, 250]];
        }

        else {
            var custom_p2_mapping = [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]];
        }

        if (typeof adsKeywords.pageType != 'undefined' && (adsKeywords.pageType.includes("article") || adsKeywords.pageType.includes("opinion"))) {
            var custom_p3_mapping = [[200, 200], [250, 250], [300, 250]];
        }

        else {
            var custom_p3_mapping = [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]];
        }

        // P1 GPT size mapping.
        var p1_mapping = googletag.sizeMapping()
        .addSize([1024, 0], custom_p1_mapping) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // P2 GPT size mapping.
        var p2_mapping = googletag.sizeMapping()
        .addSize([1024, 0], custom_p2_mapping) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // P3 GPT size mapping.
        var p3_mapping = googletag.sizeMapping()
        .addSize([1024, 0], custom_p3_mapping) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // P GPT size mapping.
        var p_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]]) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // InText & Under Article GPT size mapping.
        var inText_mapping = googletag.sizeMapping()
        .addSize([1300, 0], [[728, 90], [728, 250], [728, 280], [580, 280], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //desktop
        .addSize([469, 0], [[300, 50], [320, 50], [468, 60], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //mobile
        .build();

        // InGallery GPT size mapping.
        var inGallery_mapping = googletag.sizeMapping()
        .addSize([1300, 0], [[728, 90], [970, 66], [950, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [980, 120], [930, 180], [970, 250], [980, 240], [980, 250], [990, 250], [1060, 250], 'fluid']) //desktop
        .addSize([469, 0], [[300, 50], [320, 50], [468, 60], [320, 100], [300, 100], 'fluid']) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], 'fluid']) //mobile
        .build();

        adContainers.forEach(function(el) { // Runs through all of the wrapperAd divs.

            // **************** Sticky GPT and Prebid definition. *******************

            if (el.id === 'Adhesion') { // Check if Adhesion div is present in body. 

                // Sticky ad unit definition
                Adhesion = googletag.defineSlot(adUnitPath + 'Sticky', [[728, 90], [970, 90], [320, 50]], 'Adhesion')
                                    .defineSizeMapping(sticky_mapping)
                                    .setTargeting('position', 'Adhesion')
                                    .setTargeting('refresh_count', '0')
                                    .addService(googletag.pubads());

                // Push the defined Adhesion Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Adhesion',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[728, 90], [970, 90], [750, 100]] }, //desktop for bigger screens
                            { minViewPort: [1024, 0], sizes: [728, 90] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        floors: HB_FLOORS_CONFIG,
                        bids: [

                            
                            {bidder: "eskimi", params: {placementId: 1572}},
                            {bidder: 'ix', params: {siteId: '1096067'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560715668'}},
                            //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5868669'}},
                            { bidder: "richaudience", params: { pid: "VmYoUd5Yc0", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3340868}},
                            {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120620'}},

                            {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                            // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                            {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_Adhesion_970x90'}},
                            //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                        ]
                    }
                );

            }

            if (adWindowWidth > 1024) {

                // **************** Billboard_HP GPT definition. *******************

                if (el.id === 'Billboard_HP') { // Check if Billboard_HP div is present in body. 

                    // Billboard ad unit definition
                    Billboard_HP = googletag.defineSlot(adUnitPath + 'Billboard_HP', [[970, 250]], 'Billboard_HP')
                                        .defineSizeMapping(billboardHP_mapping)
                                        .setTargeting('position', 'Billboard_HP')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined Billboard_HP Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'Billboard_HP',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [768, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [
                                
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067700'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540578'}},
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181010}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '128359'}},
                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_Billboard_HP_970x250'}},
                            ]
                        }
                    );

                }

                // **************** Sidebar_HP GPT definition. *******************

                else if (el.id === 'Sidebar_HP' && adWindowWidth > 1260) { // Check if Sidebar_HP div is present in body. 

                    // Sidebar_HP ad unit definition
                    Sidebar_HP = googletag.defineSlot(adUnitPath + 'Sidebar_HP', [[970, 250]], 'Sidebar_HP')
                                        .defineSizeMapping(sidebarHP_mapping)
                                        .setTargeting('position', 'Sidebar_HP')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined Sidebar_HP Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'Sidebar_HP',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[300, 250], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [
                                
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067701'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540579'}},
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181014}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '128360'}},
                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_Sidebar_HP_970x250'}},
                            ]
                        }
                    );

                }

                // **************** Billboard_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'Billboard_Desktop' && adWindowWidth > 1024) { // Check if Billboard_Desktop div is present in body. 

                    // Billboard_Desktop ad unit definition
                    Billboard_Desktop = googletag.defineSlot(adUnitPath + 'Billboard', [[970, 250]], 'Billboard_Desktop')
                                        .defineSizeMapping(billboard_mapping)
                                        .setTargeting('position', 'Billboard')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined Billboard_Desktop Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'Billboard_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067702'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540580'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "HFjK4HVNSp", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181016}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120621'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_Billboard_Desktop_970x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }             

                // **************** P1_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P1_Desktop') { // Check if P1_Desktop div is present in body. 

                    // P1_Desktop ad unit definition
                    P1_Desktop = googletag.defineSlot(adUnitPath + 'P1', [[300, 250]], 'P1_Desktop')
                                .defineSizeMapping(p1_mapping)
                                .setTargeting('position', 'P1')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P1 Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'P1_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: custom_p1_mapping }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067703'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540581'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658814'}},
                                { bidder: "richaudience", params: { pid: "ZQSfYIVmwk", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181018}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120624'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P1_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }

                // **************** P2_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P2_Desktop') { // Check if P2_Desktop div is present in body. 

                    // P2_Desktop ad unit definition
                    P2_Desktop = googletag.defineSlot(adUnitPath + 'P2', [[300, 250]], 'P2_Desktop')
                                .defineSizeMapping(p2_mapping)
                                .setTargeting('position', 'P2')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P2_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P2_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: custom_p2_mapping }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067704'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540582'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658816'}},
                                { bidder: "richaudience", params: { pid: "TPCkFHIewp", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181020}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120625'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P2_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                } 

                // **************** P3_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P3_Desktop') { // Check if P3_Desktop div is present in body. 

                    // P3_Desktop ad unit definition
                    P3_Desktop = googletag.defineSlot(adUnitPath + 'P3', [[300, 250]], 'P3_Desktop')
                                .defineSizeMapping(p3_mapping)
                                .setTargeting('position', 'P3')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P3_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P3_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: custom_p3_mapping }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067705'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540583'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658817'}},
                                { bidder: "richaudience", params: { pid: "Tq6O6ghD0m", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181022}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120626'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P3_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                // **************** P4_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P4_Desktop') { // Check if P4_Desktop div is present in body. 

                    // P4_Desktop ad unit definition
                    P4_Desktop = googletag.defineSlot(adUnitPath + 'P4', [[300, 250]], 'P4_Desktop')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P4')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P4_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P4_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067706" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540584" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658819" } },
                                { bidder: "richaudience", params: { pid: "s3v0pDpR9t", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181024 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "123584" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P4_Desktop_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P5_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P5_Desktop') { // Check if P5_Desktop div is present in body. 

                    // P5_Desktop ad unit definition
                    P5_Desktop = googletag.defineSlot(adUnitPath + 'P5', [[300, 250]], 'P5_Desktop')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P5')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P5_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P5_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067707" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540585" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658820" } },
                                { bidder: "richaudience", params: { pid: "EUQXfp3CCH", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181026 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "125177" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P5_Desktop_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P6_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P6_Desktop') { // Check if P6_Desktop div is present in body. 

                    // P6_Desktop ad unit definition
                    P6_Desktop = googletag.defineSlot(adUnitPath + 'P6', [[300, 250]], 'P6_Desktop')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P6')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P6_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P6_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067708" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540586" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658821" } },
                                { bidder: "richaudience", params: { pid: "MdrAJ0J1er", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181028 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "125178" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P6_Desktop_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P7_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P7_Desktop') { // Check if P7_Desktop div is present in body. 

                    // P7_Desktop ad unit definition
                    P7_Desktop = googletag.defineSlot(adUnitPath + 'P7', [[300, 250]], 'P7_Desktop')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P7')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P7_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P7_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067709" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540587" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658822" } },
                                { bidder: "richaudience", params: { pid: "4AXB43iNRX", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181030 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "125179" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P7_Desktop_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P8_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P8_Desktop') { // Check if P8_Desktop div is present in body. 

                    // P8_Desktop ad unit definition
                    P8_Desktop = googletag.defineSlot(adUnitPath + 'P8', [[300, 250]], 'P8_Desktop')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P8')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P8_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P8_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067710" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540588" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658823" } },
                                { bidder: "richaudience", params: { pid: "bNYgpke8Jc", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181032 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "125180" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P8_Desktop_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P9_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P9_Desktop') { // Check if P9_Desktop div is present in body. 

                    // P9_Desktop ad unit definition
                    P9_Desktop = googletag.defineSlot(adUnitPath + 'P9', [[300, 250]], 'P9_Desktop')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P9')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P9_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P9_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067711" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540589" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658825" } },
                                { bidder: "richaudience", params: { pid: "91AMp048yB", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181034 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "126448" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P9_Desktop_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P10_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'P10_Desktop') { // Check if P10_Desktop div is present in body. 

                    // P10_Desktop ad unit definition
                    P10_Desktop = googletag.defineSlot(adUnitPath + 'P10', [[300, 250]], 'P10_Desktop')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P10')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P10_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P10_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067712" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540590" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658826" } },
                                { bidder: "richaudience", params: { pid: "9S6isoIis7", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181036 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "126449" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P10_Desktop_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** In_Text_1_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_1_Desktop') { // Check if In_Text_1_Desktop div is present in body. 

                    // In_Text_1_Desktop ad unit definition
                    In_Text_1_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_1', [[300, 250]], 'In_Text_1_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_1')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_1_Desktop Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Text_1_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067713'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540591'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658828'}},
                                { bidder: "richaudience", params: { pid: "5eNCsKaNwb", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181038}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120627'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_1_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                // **************** In_Text_2_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_2_Desktop') { // Check if In_Text_2_Desktop div is present in body. 

                    // In_Text_2_Desktop ad unit definition
                    In_Text_2_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_2', [[300, 250]], 'In_Text_2_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_2')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_2_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_2_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067714'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540592'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658829'}},
                                { bidder: "richaudience", params: { pid: "qmX7JJJQXl", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181040}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120628'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_2_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                // **************** In_Text_3_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_3_Desktop') { // Check if In_Text_3_Desktop div is present in body. 

                    // In_Text_3_Desktop ad unit definition
                    In_Text_3_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_3', [[300, 250]], 'In_Text_3_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_3')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_3_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_3_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067715'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540593'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "WOnUICQqA7", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181042}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120629'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_3_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                // **************** In_Text_4_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_4_Desktop') { // Check if In_Text_4_Desktop div is present in body. 

                    // In_Text_4_Desktop ad unit definition
                    In_Text_4_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_4', [[300, 250]], 'In_Text_4_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_4')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_4_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_4_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067716'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540594'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "t3JxlHAlf7", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181044}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '124582'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_4_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                // **************** In_Text_5_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_5_Desktop') { // Check if In_Text_5_Desktop div is present in body. 

                    // In_Text_5_Desktop ad unit definition
                    In_Text_5_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_5', [[300, 250]], 'In_Text_5_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_5')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_5_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_5_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067717'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540595'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "ftUQv6ubKj", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181046}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '124583'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_5_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                // **************** In_Text_6_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_6_Desktop') { // Check if In_Text_6_Desktop div is present in body. 

                    // In_Text_6_Desktop ad unit definition
                    In_Text_6_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_6', [[300, 250]], 'In_Text_6_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_6')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_6_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_6_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195191'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280672'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "cyQ8ZIhQ9T", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747720}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125172'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_6_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                // **************** In_Text_7_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_7_Desktop') { // Check if In_Text_7_Desktop div is present in body. 

                    // In_Text_7_Desktop ad unit definition
                    In_Text_7_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_7', [[300, 250]], 'In_Text_7_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_7')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_7_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_7_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195192'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280673'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "WnGBwnpxOt", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747722}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125173'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_7_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                // **************** In_Text_8_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_8_Desktop') { // Check if In_Text_8_Desktop div is present in body. 

                    // In_Text_8_Desktop ad unit definition
                    In_Text_8_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_8', [[300, 250]], 'In_Text_8_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_8')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_8_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_8_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195193'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280674'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "0ncYjbwdEx", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747724}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125174'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_8_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                // **************** In_Text_9_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_9_Desktop') { // Check if In_Text_9_Desktop div is present in body. 

                    // In_Text_9_Desktop ad unit definition
                    In_Text_9_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_9', [[300, 250]], 'In_Text_9_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_9')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_9_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_9_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195194'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280675'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "6QFEdHUFyl", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747726}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125175'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_9_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                // **************** In_Text_10_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_10_Desktop') { // Check if In_Text_10_Desktop div is present in body. 

                    // In_Text_10_Desktop ad unit definition
                    In_Text_10_Desktop = googletag.defineSlot(adUnitPath + 'In_Text_10', [[300, 250]], 'In_Text_10_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_10')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_10_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_10_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195195'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280676'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "h9mRv8xkUi", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747728}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125176'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_10_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                // **************** Under_Article_Desktop GPT and Prebid definition. *******************

                else if (el.id === 'Under_Article_Desktop') { // Check if Under_Article_Desktop div is present in body. 

                    // Under_Article_Desktop ad unit definition
                    Under_Article_Desktop = googletag.defineSlot(adUnitPath + 'Under_Article', [[300, 250]], 'Under_Article_Desktop')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'Under_Article')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined Under_Article_Desktop Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'Under_Article_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1300, 0], sizes: [[728, 90], [300, 250], [336, 280], [750, 280], [750, 200], [580, 280]] }, //desktop
                                { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195196'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280677'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "mnFLjRCMjg", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747730}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '141733'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_Under_Article_Desktop_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }                  

                 // **************** In_Gallery_1_Desktop GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_1_Desktop') { // Check if In_Gallery_1_Desktop div is present in body. 

                    // In_Gallery_1_Desktop ad unit definition
                    In_Gallery_1_Desktop = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_1_Desktop')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_1')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_1_Desktop Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_1_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_1_Desktop_970x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }       

                 // **************** In_Gallery_2_Desktop GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_2_Desktop') { // Check if In_Gallery_2_Desktop div is present in body. 

                    // In_Gallery_2_Desktop ad unit definition
                    In_Gallery_2_Desktop = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_2_Desktop')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_2')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_2_Desktop Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_2_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_2_Desktop_970x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                 // **************** In_Gallery_3_Desktop GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_3_Desktop') { // Check if In_Gallery_3_Desktop div is present in body. 

                    // In_Gallery_3_Desktop ad unit definition
                    In_Gallery_3_Desktop = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_3_Desktop')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_3')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_3_Desktop Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_3_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_3_Desktop_970x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                } 

                 // **************** In_Gallery_4_Desktop GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_4_Desktop') { // Check if In_Gallery_4_Desktop div is present in body. 

                    // In_Gallery_4_Desktop ad unit definition
                    In_Gallery_4_Desktop = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_4_Desktop')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_4')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_4_Desktop Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_4_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_4_Desktop_970x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                } 

                 // **************** In_Gallery_5_Desktop GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_5_Desktop') { // Check if In_Gallery_5_Desktop div is present in body. 

                    // In_Gallery_5_Desktop ad unit definition
                    In_Gallery_5_Desktop = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_5_Desktop')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_5')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_5_Desktop Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_5_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_5_Desktop_970x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                } 

            }

            // If adWindowWidth < 1024 (for tablet and mobile devices)

            else {

                // **************** Billboard_Mobile GPT and Prebid definition. *******************

                if (el.id === 'Billboard_Mobile') { // Check if Billboard_Mobile div is present in body. 

                    // Billboard_Mobile ad unit definition
                    Billboard_Mobile = googletag.defineSlot(adUnitPath + 'Billboard', [[970, 250]], 'Billboard_Mobile')
                                        .defineSizeMapping(billboard_mapping)
                                        .setTargeting('position', 'Billboard')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined Billboard_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'Billboard_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067702'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540580'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "HFjK4HVNSp", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181016}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120621'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_Billboard_Mobile_320x50'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }

                // **************** P1_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P1_Mobile') { // Check if P1_Mobile div is present in body. 

                    // P1_Mobile ad unit definition
                    P1_Mobile = googletag.defineSlot(adUnitPath + 'P1', [[300, 250]], 'P1_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P1')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P1_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'P1_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067703'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540581'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658814'}},
                                { bidder: "richaudience", params: { pid: "ZQSfYIVmwk", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181018}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120624'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P1_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                } 

                // **************** P2_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P2_Mobile') { // Check if P2_Mobile div is present in body. 

                    // P2_Mobile ad unit definition
                    P2_Mobile = googletag.defineSlot(adUnitPath + 'P2', [[300, 250]], 'P2_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P2')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P2_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P2_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067704'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540582'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658816'}},
                                { bidder: "richaudience", params: { pid: "TPCkFHIewp", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181020}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120625'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P2_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                } 

                // **************** P3_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P3_Mobile') { // Check if P3_Mobile div is present in body. 

                    // P3_Mobile ad unit definition
                    P3_Mobile = googletag.defineSlot(adUnitPath + 'P3', [[300, 250]], 'P3_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P3')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P3_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P3_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1067705'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540583'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658817'}},
                                { bidder: "richaudience", params: { pid: "Tq6O6ghD0m", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181022}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120626'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P3_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                // **************** P4_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P4_Mobile') { // Check if P4_Mobile div is present in body. 

                    // P4_Mobile ad unit definition
                    P4_Mobile = googletag.defineSlot(adUnitPath + 'P4', [[300, 250]], 'P4_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P4')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P4_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P4_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067706" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540584" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658819" } },
                                { bidder: "richaudience", params: { pid: "s3v0pDpR9t", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181024 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "123584" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P4_Mobile_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P5_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P5_Mobile') { // Check if P5_Mobile div is present in body. 

                    // P5_Mobile ad unit definition
                    P5_Mobile = googletag.defineSlot(adUnitPath + 'P5', [[300, 250]], 'P5_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P5')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P5_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P5_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067707" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540585" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658820" } },
                                { bidder: "richaudience", params: { pid: "EUQXfp3CCH", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181026 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "125177" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P5_Mobile_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P6_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P6_Mobile') { // Check if P6_Mobile div is present in body. 

                    // P6_Mobile ad unit definition
                    P6_Mobile = googletag.defineSlot(adUnitPath + 'P6', [[300, 250]], 'P6_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P6')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P6_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P6_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067708" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540586" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658821" } },
                                { bidder: "richaudience", params: { pid: "MdrAJ0J1er", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181028 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "125178" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P6_Mobile_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P7_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P7_Mobile') { // Check if P7_Mobile div is present in body. 

                    // P7_Mobile ad unit definition
                    P7_Mobile = googletag.defineSlot(adUnitPath + 'P7', [[300, 250]], 'P7_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P7')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P7_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P7_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067709" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540587" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658822" } },
                                { bidder: "richaudience", params: { pid: "4AXB43iNRX", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181030 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "125179" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P7_Mobile_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P8_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P8_Mobile') { // Check if P8_Mobile div is present in body. 

                    // P8_Mobile ad unit definition
                    P8_Mobile = googletag.defineSlot(adUnitPath + 'P8', [[300, 250]], 'P8_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P8')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P8_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P8_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067710" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540588" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658823" } },
                                { bidder: "richaudience", params: { pid: "bNYgpke8Jc", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181032 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "125180" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P8_Mobile_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P9_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P9_Mobile') { // Check if P9_Mobile div is present in body. 

                    // P9_Mobile ad unit definition
                    P9_Mobile = googletag.defineSlot(adUnitPath + 'P9', [[300, 250]], 'P9_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P9')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P9_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P9_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067711" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540589" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658825" } },
                                { bidder: "richaudience", params: { pid: "91AMp048yB", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181034 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "126448" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P9_Mobile_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** P10_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'P10_Mobile') { // Check if P10_Mobile div is present in body. 

                    // P10_Mobile ad unit definition
                    P10_Mobile = googletag.defineSlot(adUnitPath + 'P10', [[300, 250]], 'P10_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P10')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P10_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'P10_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{ bidder: "connectad", params: { networkId: 44, siteId: 1066265 } },
                                {bidder: "eskimi", params: {placementId: 1572}},
                                { bidder: "ix", params: { siteId: "1067712" } },
                                { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "560540590" } },
                                //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5658826" } },
                                { bidder: "richaudience", params: { pid: "9S6isoIis7", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                { bidder: "magnite", params: { accountId: 19712, siteId: 526612, zoneId: 3181036 } },
                                { bidder: "equativ", params: { networkId: "4527", siteId: "636321", pageId: "1927639", formatId: "126449" } },

                                { bidder: 'teads', params: {pageId: 182473, placementId: 197478 } },
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_P10_Mobile_300x250'}},
                                //{ bidder: "yandex", params: { placementId: 'R-A-5837895-1', cur: 'EUR' } },
                            ]
                        }
                    );

                }   

                // **************** In_Text_1_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_1_Mobile') { // Check if In_Text_1_Mobile div is present in body. 

                    // In_Text_1_Mobile ad unit definition
                    In_Text_1_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_1', [[300, 250]], 'In_Text_1_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_1')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_1_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Text_1_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067713'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540591'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658828'}},
                                { bidder: "richaudience", params: { pid: "5eNCsKaNwb", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181038}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120627'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_1_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }   

                // **************** In_Text_2_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_2_Mobile') { // Check if In_Text_2_Mobile div is present in body. 

                    // In_Text_2_Mobile ad unit definition
                    In_Text_2_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_2', [[300, 250]], 'In_Text_2_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_2')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_2_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_2_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067714'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540592'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658829'}},
                                { bidder: "richaudience", params: { pid: "qmX7JJJQXl", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181040}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120628'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_2_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }       

                // **************** In_Text_3_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_3_Mobile') { // Check if In_Text_3_Mobile div is present in body. 

                    // In_Text_3_Mobile ad unit definition
                    In_Text_3_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_3', [[300, 250]], 'In_Text_3_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_3')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_3_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_3_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067715'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540593'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "WOnUICQqA7", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181042}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '120629'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_3_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }    

                // **************** In_Text_4_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_4_Mobile') { // Check if In_Text_4_Mobile div is present in body. 

                    // In_Text_4_Mobile ad unit definition
                    In_Text_4_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_4', [[300, 250]], 'In_Text_4_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_4')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_4_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_4_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067716'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540594'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "t3JxlHAlf7", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181044}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '124582'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_4_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }    

                // **************** In_Text_5_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_5_Mobile') { // Check if In_Text_5_Mobile div is present in body. 

                    // In_Text_5_Mobile ad unit definition
                    In_Text_5_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_5', [[300, 250]], 'In_Text_5_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_5')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_5_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_5_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1067717'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '560540595'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "ftUQv6ubKj", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3181046}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '124583'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_5_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }    

                // **************** In_Text_6_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_6_Mobile') { // Check if In_Text_6_Mobile div is present in body. 

                    // In_Text_6_Mobile ad unit definition
                    In_Text_6_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_6', [[300, 250]], 'In_Text_6_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_6')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_6_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_6_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195191'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280672'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "cyQ8ZIhQ9T", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747720}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125172'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_6_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }    

                // **************** In_Text_7_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_7_Mobile') { // Check if In_Text_7_Mobile div is present in body. 

                    // In_Text_7_Mobile ad unit definition
                    In_Text_7_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_7', [[300, 250]], 'In_Text_7_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_7')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_7_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_7_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195192'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280673'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "WnGBwnpxOt", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747722}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125173'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_7_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }    

                // **************** In_Text_8_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_8_Mobile') { // Check if In_Text_8_Mobile div is present in body. 

                    // In_Text_8_Mobile ad unit definition
                    In_Text_8_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_8', [[300, 250]], 'In_Text_8_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_8')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_8_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_8_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195193'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280674'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "0ncYjbwdEx", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747724}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125174'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_8_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                // **************** In_Text_9_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_9_Mobile') { // Check if In_Text_9_Mobile div is present in body. 

                    // In_Text_9_Mobile ad unit definition
                    In_Text_9_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_9', [[300, 250]], 'In_Text_9_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_9')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_9_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_9_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195194'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280675'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "6QFEdHUFyl", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747726}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125175'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_9_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                // **************** In_Text_10_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'In_Text_10_Mobile') { // Check if In_Text_10_Mobile div is present in body. 

                    // In_Text_10_Mobile ad unit definition
                    In_Text_10_Mobile = googletag.defineSlot(adUnitPath + 'In_Text_10', [[300, 250]], 'In_Text_10_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'In_Text_10')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Text_10_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'In_Text_10_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195195'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280676'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "h9mRv8xkUi", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747728}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '125176'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Text_10_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                // **************** Under_Article_Mobile GPT and Prebid definition. *******************

                else if (el.id === 'Under_Article_Mobile') { // Check if Under_Article_Mobile div is present in body. 

                    // Under_Article_Mobile ad unit definition
                    Under_Article_Mobile = googletag.defineSlot(adUnitPath + 'Under_Article', [[300, 250]], 'Under_Article_Mobile')
                                        .defineSizeMapping(inText_mapping)
                                        .setTargeting('position', 'Under_Article')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined Under_Article_Mobile Prebid placement IDs to the BTF array.      
                    adUnitsBTF.push(
                        {   code: 'Under_Article_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [] }, //desktop
                                { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 100], [320, 100], [250, 250], [300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                //{bidder: 'cwire', params: {pageId: 422, placementId: 69553544}},
                                {bidder: 'ix', params: {siteId: '1195196'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562280677'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658830'}},
                                { bidder: "richaudience", params: { pid: "mnFLjRCMjg", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3747730}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '141733'}},

                                {bidder: 'teads', params: {pageId: 182474, placementId: 197479}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_Under_Article_Mobile_300x250'}},
                                //{bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                 // **************** In_Gallery_1_Mobile GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_1_Mobile') { // Check if In_Gallery_1_Mobile div is present in body. 

                    // In_Gallery_1_Mobile ad unit definition
                    In_Gallery_1_Mobile = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_1_Mobile')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_1')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_1_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_1_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_1_Mobile_970x250'}},
                               // {bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }    

                 // **************** In_Gallery_2_Mobile GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_2_Mobile') { // Check if In_Gallery_2_Mobile div is present in body. 

                    // In_Gallery_2_Mobile ad unit definition
                    In_Gallery_2_Mobile = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_2_Mobile')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_2')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_2_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_2_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_2_Mobile_970x250'}},
                               // {bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                 // **************** In_Gallery_3_Mobile GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_3_Mobile') { // Check if In_Gallery_3_Mobile div is present in body. 

                    // In_Gallery_3_Mobile ad unit definition
                    In_Gallery_3_Mobile = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_3_Mobile')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_3')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_3_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_3_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_3_Mobile_970x250'}},
                               // {bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                 // **************** In_Gallery_4_Mobile GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_4_Mobile') { // Check if In_Gallery_4_Mobile div is present in body. 

                    // In_Gallery_4_Mobile ad unit definition
                    In_Gallery_4_Mobile = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_4_Mobile')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_4')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_4_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_4_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_4_Mobile_970x250'}},
                               // {bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }  

                 // **************** In_Gallery_5_Mobile GPT and Prebid definition. *******************

                 else if (el.id === 'In_Gallery_5_Mobile') { // Check if In_Gallery_5_Mobile div is present in body. 

                    // In_Gallery_5_Mobile ad unit definition
                    In_Gallery_5_Mobile = googletag.defineSlot(adUnitPath + 'In_Gallery', [[970, 250]], 'In_Gallery_5_Mobile')
                                        .defineSizeMapping(inGallery_mapping)
                                        .setTargeting('position', 'In_Gallery_5')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined In_Gallery_5_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'In_Gallery_5_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                                { minViewPort: [469, 0], sizes: [] }, //tablet
                                { minViewPort: [0, 0], sizes: [] }, //mobile
                            ]
                            }},
                            floors: HB_FLOORS_CONFIG,
                            bids: [

                                
                                //{bidder: 'connectad', params: {networkId: 44, siteId: 1066265}},
                                {bidder: "eskimi", params: {placementId: 1572}},
                                {bidder: 'ix', params: {siteId: '1187918'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562029344'}},
                                //{bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '5658813'}},
                                { bidder: "richaudience", params: { pid: "gIIfyR8zSN", supplyType: "site" } },
                                { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE" } },
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 526612, zoneId: 3714988}},
                                {bidder: 'equativ', params: {networkId: '4527', siteId: '636321', pageId: '1927639', formatId: '140317'}},

                                {bidder: 'teads', params: {pageId: 182473, placementId: 197478}},
                                // Taboola (added 28.08.2026). tagId = fixed prefix 100008802 + this ad unit code + a reporting-only size suffix.
                                {bidder: 'taboola', params: {publisherId: '2085250', tagId: '100008802_In_Gallery_5_Mobile_970x250'}},
                               // {bidder: "yandex", params: {placementId: 'R-A-5837895-1', cur: 'EUR'}},
                            ]
                        }
                    );

                }

            }

        }); // End of wrapperAd divs check. 

        //Create sticky ad once the ad is ready to render
        googletag.pubads().addEventListener('slotRenderEnded', function(event) {

            let unitPath = event.slot.getAdUnitPath(); //get the ad unith path for the slot which will render the ad
            let stickyBackground = document.getElementById('adhesion_background'); //get the adhesion background id
            //let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

            if (unitPath === adUnitPath + "Sticky" && event.isEmpty === true) {
                let sticky = document.getElementById('Adhesion');
                sticky.style.display = 'none';
            }

            // if ad unit is sticky and the background is not set, set sticky CSS for sticky ad unit
            else if (unitPath === adUnitPath + "Sticky" && stickyBackground === null){
            let sticky = document.getElementById('Adhesion');
            sticky.style.position = 'fixed';
            sticky.style.zIndex = '999999';
            sticky.style.width = '100%';
            sticky.style.height = '';
            sticky.style.bottom = '0px';
            sticky.style.textAlign = 'center';	
            sticky.style.padding = '10px 0px 0px';
            sticky.style.borderTop = '1px #CCC solid';

            // create adhesion background
            let background = document.createElement("div");
            background.setAttribute("ID", "adhesion_background");
            background.style.backgroundColor = '#FFF';

            if (adWindowWidth > 1024) {
                background.style.opacity = '70%';
            }

            else {
                background.style.opacity = '100%';
            }

            background.style.position = 'absolute';
            background.style.height = '100%';
            background.style.width = '100%';
            background.style.top = '0';
            background.style.left = '0';
            background.style.zIndex = '-1';
            sticky.appendChild(background);

            // create placeholder text
            /*let placeholder = document.createElement("div");
            placeholder.setAttribute("ID", "adText");
            placeholder.style.textAlign = 'center';
            placeholder.style.fontSize = '10px';
            placeholder.style.color = '#CCC';
            placeholder.style.height = '20px';
            placeholder.style.borderTop = '1px #CCC solid';
            placeholder.style.paddingTop = '2px';
            placeholder.textContent = 'Oglas'
            background.appendChild(placeholder);*/

            // create close button with svg elements
            let closeButton = document.createElement("div");
            closeButton.setAttribute("ID", "close_adhesion")
            closeButton.style.position = 'absolute';
            closeButton.style.top = '-29px';
            closeButton.style.right = '0px';
            closeButton.style.cursor = 'pointer';
            closeButton.style.padding = '8px';
            //closeButton.style.borderRadius = '50%';
            closeButton.style.border = '1px solid #CCC';
            //closeButton.style.boxShadow = '0 0 3px #b8b9be';
            closeButton.style.background = '#FFF';
            closeButton.style.borderBottom = '1px solid #FFF';
            closeButton.style.borderTopLeftRadius = '10px';

            let iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            let iconPath = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path'
            );

            iconSvg.setAttribute('display', 'block');
            iconSvg.setAttribute('fill', '#000');
            iconSvg.setAttribute('width', '12px');
            iconSvg.setAttribute('height', '12px');
            iconSvg.setAttribute('viewBox', '0 0 8 8');

            iconPath.setAttribute(
                'd',
                'M1.41 0l-1.41 1.41.72.72 1.78 1.81-1.78 1.78-.72.69 1.41 1.44.72-.72 1.81-1.81 1.78 1.81.69.72 1.44-1.44-.72-.69-1.81-1.78 1.81-1.81.72-.72-1.44-1.41-.69.72-1.78 1.78-1.81-1.78-.72-.72z'
            );

            iconSvg.appendChild(iconPath);
            closeButton.appendChild(iconSvg); 
            sticky.appendChild(closeButton);

            // when user clicks the close button, remove the sticky div
            document.getElementById("close_adhesion").addEventListener('click', function(e) {
                e.preventDefault();
                sticky.parentNode.removeChild(sticky);
            }, false); 

            } 
        });

        // Check if adsKeywords object is present
        if (typeof adsKeywords != 'undefined') {

            // Check if adsKeywords attributes are present, if so, pass them as key values to GAM
            if (typeof adsKeywords.interests != 'undefined') {
                googletag.pubads().setTargeting('interests', [adsKeywords.interests].join(','));
            } 

            if (typeof adsKeywords.pageType != 'undefined') {
                googletag.pubads().setTargeting('pageType', adsKeywords.pageType);
            } 

            if (typeof adsKeywords.id != 'undefined') {
                googletag.pubads().setTargeting('articleId', [adsKeywords.id].join(','));
            } 

        }


        try {
        // CX targeting
        if(typeof window.localStorage === 'object' && typeof window.localStorage.getItem === 'function' && localStorage.getItem("CxSegments") !== null && localStorage.getItem("CxSegments").length>0) {
            googletag.pubads().setTargeting('CxSegments', localStorage.getItem('CxSegments').split(','));
        }

        if(typeof window.localStorage === 'object' && typeof window.localStorage.getItem === 'function' && localStorage.getItem("CxCmbnd") !== null && localStorage.getItem("CxCmbnd").length>0) {
            googletag.pubads().setTargeting('CxCmbnd', localStorage.getItem('CxCmbnd').split(','))
        }


        } catch (e) {}
let adQueryString = window.location.search; // Get the whole string in the URL. 
        //console.log("Query string is " + adQueryString);

        let adUrlParams = new URLSearchParams(adQueryString); // Get the information after ? in the URL. 
        //console.log("URL param is " +  adUrlParams);

        if (adUrlParams.has('adTest')) { 
            let adValue = adUrlParams.get('adTest'); // If there is a adTest param get the value after =. 
            //console.log("AdTest value is " + adValue);
            googletag.pubads().setTargeting('adTest', adValue); // Send the adTest value to GAM.
        } 

        if (adUrlParams.has('utm_source')) {
            let utmSource = adUrlParams.get('utm_source'); // If there is a utm_source param get the value after =. 
            //console.log("UTM source value is " + utmSource);
            googletag.pubads().setTargeting('utmSource', utmSource); // Send the utm_source value to GAM.
        } 

        if (adUrlParams.has('utm_medium')) {
            let utmMedium = adUrlParams.get('utm_medium'); // If there is a utm_medium param get the value after =. 
            //console.log("UTM medium value is " + utmMedium);
            googletag.pubads().setTargeting('utmMedium', utmMedium); // Send the utm_medium value to GAM.
        } 

        let refURL = document.referrer; // Get the URL from which the user came. 

        if (refURL.length === 0) {
            googletag.pubads().setTargeting('referrer', 'direct');
        } 

        else if (refURL.includes("google")) {
            googletag.pubads().setTargeting('referrer', 'google');
        } 

        else if (refURL.includes("linkedin") || refURL.includes("t.com") || refURL.includes("facebook") || refURL.includes("instagram")) {
            googletag.pubads().setTargeting('referrer', 'social');
        } 

        else if (refURL.includes("blic.rs") || refURL.includes("pulsonline.rs") || refURL.includes("ana.rs") || refURL.includes("nekretnine.rs") || refURL.includes("mojauto.rs")) {
            googletag.pubads().setTargeting('referrer', 'ringier');
        } 

        else {
            googletag.pubads().setTargeting('referrer', 'other');
        }

        // Initial requests are first impressions. Keep a bucket in GAM for refresh performance reporting.
        googletag.pubads().getSlots().forEach(function(slot) {
            slot.setTargeting('refresh_bucket', 'r0');
        });

        googletag.pubads().disableInitialLoad(); // Disables requests for ads on page load. 
        googletag.pubads().enableSingleRequest(); // Enables single request mode for fetching multiple ads at the same time.
        googletag.pubads().setCentering(true);
        googletag.enableServices(); // Enables all GPT services that have been defined for ad slots on the page.

        // Get the list of slots associated with this service.
        googletag.pubads().getSlots().forEach(function(adSlots) {
            googletag.display(adSlots.getSlotElementId()); // Instructs slot services to render all of the defined ad slots. 
        });

    });

    pbjs.que.push(function() {

        pbjs.setConfig({

            priceGranularity: 'high', //$0.01 increments, up to $20

            enableSendAllBids: false, //send only top bids
            targetingControls: {
              alwaysIncludeDeals: true //send all deal bids
            },

            //Currency module
            currency: {
                "adServerCurrency": "EUR",
                "conversionRateFile": "https://cdn.jsdelivr.net/gh/prebid/currency-file@1/latest.json",
             },

            //Coockie match and user syncs
            userSync: {
                syncEnabled: true,
                syncsPerBidder: 5,
                syncDelay: 3000,
                auctionDelay: 50,
                userIds: [

                    { name: "sharedId", 
                      storage: { type: "cookie", name: "_sharedid", expires: 365 } 
                    },

                    { name: "id5Id",
                        params: { partner: 1355, externalModuleUrl: 'https://cdn.id5-sync.com/api/1.0/id5PrebidModule.js' },
                        storage: { type: "html5", name: "id5id", expires: 90, refreshInSeconds: 8*3600 }
                    },

                    { name: 'teadsId',
                      params: { pubId: 26849 }
                    },

                    { name: 'lotamePanoramaId',
                    },

                ],
                aliasSyncEnabled: true,
                filterSettings: { all: { bidders: "*", filter: "include" } },
                /*topics: {
                    bidders: [{
                      bidder: 'yandex',
                      iframeURL: 'https://yandex.ru/ads/prebid/topics_frame.html'
                    }]
                }*/
            },

            enableTIDs: true,

            consentManagement: {
                gdpr: {
                  cmpApi: 'iab',
                  timeout: 8000,
                  defaultGdprScope: true
                }
            },

            /*paapi: {
                enabled: true,
                gpt: {
                    autoconfig: false
                },
                defaultForSlots: 1
            },*/

            //useBidCache: true,

        });

        pbjs.bidderSettings = {
            standard: {
                storageAllowed: true,
            },

            // Taboola-specific settings (added 28.08.2026).
            // Both keys must live in this one object: a separate assignment to pbjs.bidderSettings later
            // in the file would replace the whole object and silently drop the 'standard' block above.
            // The key must be lowercase 'taboola' - Prebid matches it against the bidder code exactly.
            taboola: {
                // Taboola reads and writes its user ID in localStorage; the storageControl module in
                // this Prebid build enforces this flag. 'standard' already grants it, this makes it explicit.
                storageAllowed: true,

                // Taboola submits GROSS bids, while every other bidder in this wrapper bids NET.
                // Multiply by 0.75 so Taboola competes on equal terms in the auction and in GAM.
                // Without this, Taboola bids would be roughly 33% overstated against every other bidder
                // and would win auctions they should lose. Remove this only if the whole stack moves to gross.
                // Note: Taboola quotes USD and adServerCurrency is EUR, so the final cpm/originalCpm ratio
                // seen in the page is FX x 0.75 (about 0.64), not 0.75 - that is expected, not a bug.
                bidCpmAdjustment: function(bidCpm) {
                    return bidCpm * 0.75;
                },
            },
        }; 

        //Add only ATF ad units.
        pbjs.addAdUnits(adUnitsATF);

        //Request bids.
        try {
            pbjs.requestBids({
                bidsBackHandler: function() {
                    initAdserver('prebid_bids_back');
                },
                timeout: PREBID_TIMEOUT
            });
        } catch (e) {
            // Prebid is optional for serving. If auction startup throws, continue with GAM.
            initAdserver('prebid_request_error');
        }
    });

    // Safety fallback: the first GAM request must never depend only on optional async callbacks.
    // This is intentionally outside pbjs.que, so ads still request even if Prebid queue/module hangs.
    setTimeout(function() {
        initAdserver('fallback_timeout');
    }, PREBID_TIMEOUT + 500);

    function getInitialGptSlots() {
        return [
            Adhesion,
            Billboard_HP,
            Sidebar_HP,
            Billboard_Desktop,
            Billboard_Mobile,
            P1_Desktop,
            P1_Mobile,
            In_Text_1_Desktop,
            In_Text_1_Mobile
        ].filter(function(slot) {
            return !!slot;
        });
    }

    function setPpidFromLocalStorageIfAvailable() {
        try {
            var id5Value = window.localStorage.getItem('id5id');

            if (!id5Value) {
                return;
            }

            var parsedId5 = JSON.parse(decodeURIComponent(id5Value));
            var ppid = parsedId5 && parsedId5.gp;

            if (ppid) {
                googletag.pubads().setPublisherProvidedId(ppid);
            }
        } catch (e) {
            // PPID is optional. Never block the ad request because of ID storage/parsing issues.
        }
    }

    function idListContains(list, id) {
        if (id === null || typeof id === 'undefined') {
            return false;
        }

        return (list || []).map(function(item) {
            return String(item);
        }).indexOf(String(id)) !== -1;
    }

    function getRefreshBucket(refreshCount) {
        var count = parseInt(refreshCount, 10) || 0;

        if (count === 0) {
            return 'r0';
        }

        if (count <= 3) {
            return 'r1_3';
        }

        return 'r4_plus';
    }

    function getSlotRefreshCount(slot) {
        var targeting = slot.getTargeting('refresh_count');
        return parseInt(targeting && targeting[0], 10) || 0;
    }

    function isBillboardSlot(divId) {
        return divId === 'Billboard_HP' ||
            divId === 'Billboard_Desktop' ||
            divId === 'Billboard_Mobile';
    }

    function getRefreshDelaySeconds(divId) {
        if (divId === 'Adhesion') {
            return STICKY_SECONDS_TO_WAIT_AFTER_VIEWABILITY;
        }

        if (isBillboardSlot(divId)) {
            return BILLBOARD_SECONDS_TO_WAIT_AFTER_VIEWABILITY;
        }

        return DEFAULT_SECONDS_TO_WAIT_AFTER_VIEWABILITY;
    }

    function isNoRefreshSlot(slot) {
        var divId = slot.getSlotElementId();
        var responseInfo = null;

        try {
            responseInfo = slot.getResponseInformation();
        } catch (e) {
            responseInfo = null;
        }

        responseInfo = responseInfo || {};

        var isAdhesionLineItemExcluded = divId === 'Adhesion' && (
            idListContains(GAM_NOREFRESH_ADHESION_LINE_ITEM_IDS, responseInfo.lineItemId) ||
            idListContains(GAM_NOREFRESH_ADHESION_LINE_ITEM_IDS, responseInfo.sourceAgnosticLineItemId)
        );

        return idListContains(GAM_NOREFRESH_ADUNITS, divId) ||
            idListContains(GAM_NOREFRESH_ADVERTISER_IDS, responseInfo.advertiserId) ||
            idListContains(GAM_NOREFRESH_ORDER_IDS, responseInfo.campaignId) ||
            idListContains(GAM_NOREFRESH_ORDER_IDS, responseInfo.orderId) ||
            isAdhesionLineItemExcluded;
    }

    function refreshSlotWithBestEffortPrebid(slot, slotId, done) {
        var refreshDone = false;

        function refreshGpt(reason) {
            if (refreshDone) {
                return;
            }

            refreshDone = true;

            googletag.cmd.push(function() {
                try {
                    if (window.pbjs && typeof pbjs.setTargetingForGPTAsync === 'function') {
                        pbjs.setTargetingForGPTAsync([slotId]);
                    }
                } catch (e) {
                    // Header bidding targeting is optional. GAM refresh must still happen.
                }

                googletag.pubads().refresh([slot]);

                if (typeof done === 'function') {
                    done(reason);
                }
            });
        }

        try {
            if (!window.pbjs || !pbjs.que || typeof pbjs.requestBids !== 'function') {
                refreshGpt('prebid_unavailable');
                return;
            }

            pbjs.que.push(function() {
                try {
                    pbjs.requestBids({
                        timeout: PREBID_TIMEOUT,
                        adUnitCodes: [slotId],
                        bidsBackHandler: function() {
                            refreshGpt('prebid_bids_back');
                        }
                    });
                } catch (e) {
                    refreshGpt('prebid_request_error');
                }
            });

            // Refresh should not hang forever if Prebid or an optional ID module stalls.
            setTimeout(function() {
                refreshGpt('refresh_fallback_timeout');
            }, PREBID_TIMEOUT + 300);
        } catch (e) {
            refreshGpt('prebid_queue_error');
        }
    }

    // Send requests to GAM for the initial ATF slots.
    // Header bidding and user IDs are best-effort only; they must never block the first ad request.
    function initAdserver(reason) {
        if (window.__sportalInitialRefreshDone || pbjs.initAdserverSet) return;
        window.__sportalInitialRefreshDone = true;
        pbjs.initAdserverSet = true;

        googletag.cmd.push(function() {
            var initialSlots = getInitialGptSlots();

            setPpidFromLocalStorageIfAvailable();

            try {
                if (window.pbjs && typeof pbjs.setTargetingForGPTAsync === 'function') {
                    pbjs.setTargetingForGPTAsync();
                }
                //pbjs.setPAAPIConfigForGPT();
            } catch (e) {
                // Header bidding targeting is optional. GAM must still be requested.
            }

            if (initialSlots.length) {
                googletag.pubads().refresh(initialSlots);
            } else {
                googletag.pubads().refresh();
            }
        });
    };

    //Add BTF ad units.
    pbjs.que.push(function() {
        pbjs.addAdUnits(adUnitsBTF);
    });

    // Use IntersectionObserver API to check whether an ad slot is at the certain distance. 
    var observer = new IntersectionObserver (function(entries) {

        entries.forEach(entry => {

            if (entry.isIntersecting) {

                let adSlot = entry.target.id; // Get the div id of the slot being observed. 

                // Request bids and push the ads to GAM. 
                pbjs.que.push(function() {
                    pbjs.requestBids({
                        timeout: PREBID_TIMEOUT,
                        adUnitCodes: [adSlot],
                        bidsBackHandler: function() {
                            pbjs.setTargetingForGPTAsync([adSlot]);

                            // If div with the certain ID is present and observed, refresh GAM slot.

                            if (adWindowWidth > 1024) {

                                if (adSlot === 'P2_Desktop') {
                                    googletag.pubads().refresh([P2_Desktop]); 
                                } 

                                else if (adSlot === 'P3_Desktop') {
                                    googletag.pubads().refresh([P3_Desktop]); 
                                } 

                                else if (adSlot === 'P4_Desktop') {
                                    googletag.pubads().refresh([P4_Desktop]); 
                                } 

                                else if (adSlot === 'P5_Desktop') {
                                    googletag.pubads().refresh([P5_Desktop]); 
                                } 

                                else if (adSlot === 'P6_Desktop') {
                                    googletag.pubads().refresh([P6_Desktop]); 
                                } 

                                else if (adSlot === 'P7_Desktop') {
                                    googletag.pubads().refresh([P7_Desktop]); 
                                } 

                                else if (adSlot === 'P8_Desktop') {
                                    googletag.pubads().refresh([P8_Desktop]); 
                                } 

                                else if (adSlot === 'P9_Desktop') {
                                    googletag.pubads().refresh([P9_Desktop]); 
                                } 

                                else if (adSlot === 'P10_Desktop') {
                                    googletag.pubads().refresh([P10_Desktop]); 
                                } 

                                else if (adSlot === 'In_Text_2_Desktop') {
                                    googletag.pubads().refresh([In_Text_2_Desktop]); 
                                } 

                                else if (adSlot === 'In_Text_3_Desktop') {
                                    googletag.pubads().refresh([In_Text_3_Desktop]); 
                                } 

                                else if (adSlot === 'In_Text_4_Desktop') {
                                    googletag.pubads().refresh([In_Text_4_Desktop]); 
                                } 

                                else if (adSlot === 'In_Text_5_Desktop') {
                                    googletag.pubads().refresh([In_Text_5_Desktop]); 
                                } 

                                else if (adSlot === 'In_Text_6_Desktop') {
                                    googletag.pubads().refresh([In_Text_6_Desktop]); 
                                } 

                                else if (adSlot === 'In_Text_7_Desktop') {
                                    googletag.pubads().refresh([In_Text_7_Desktop]); 
                                } 

                                else if (adSlot === 'In_Text_8_Desktop') {
                                    googletag.pubads().refresh([In_Text_8_Desktop]); 
                                } 

                                else if (adSlot === 'In_Text_9_Desktop') {
                                    googletag.pubads().refresh([In_Text_9_Desktop]); 
                                } 

                                else if (adSlot === 'In_Text_10_Desktop') {
                                    googletag.pubads().refresh([In_Text_10_Desktop]); 
                                } 

                                else if (adSlot === 'Under_Article_Desktop') {
                                    googletag.pubads().refresh([Under_Article_Desktop]); 
                                } 

                                else if (adSlot === 'In_Gallery_1_Desktop') {
                                    googletag.pubads().refresh([In_Gallery_1_Desktop]); 
                                } 

                                else if (adSlot === 'In_Gallery_2_Desktop') {
                                    googletag.pubads().refresh([In_Gallery_2_Desktop]); 
                                } 

                                else if (adSlot === 'In_Gallery_3_Desktop') {
                                    googletag.pubads().refresh([In_Gallery_3_Desktop]); 
                                } 

                                else if (adSlot === 'In_Gallery_4_Desktop') {
                                    googletag.pubads().refresh([In_Gallery_4_Desktop]); 
                                } 

                                else if (adSlot === 'In_Gallery_5_Desktop') {
                                    googletag.pubads().refresh([In_Gallery_5_Desktop]); 
                                } 

                            }

                            else {

                                if (adSlot === 'P2_Mobile') {
                                    googletag.pubads().refresh([P2_Mobile]); 
                                } 

                                else if (adSlot === 'P3_Mobile') {
                                    googletag.pubads().refresh([P3_Mobile]); 
                                } 

                                else if (adSlot === 'P4_Mobile') {
                                    googletag.pubads().refresh([P4_Mobile]); 
                                } 

                                else if (adSlot === 'P5_Mobile') {
                                    googletag.pubads().refresh([P5_Mobile]); 
                                } 

                                else if (adSlot === 'P6_Mobile') {
                                    googletag.pubads().refresh([P6_Mobile]); 
                                } 

                                else if (adSlot === 'P7_Mobile') {
                                    googletag.pubads().refresh([P7_Mobile]); 
                                } 

                                else if (adSlot === 'P8_Mobile') {
                                    googletag.pubads().refresh([P8_Mobile]); 
                                } 

                                else if (adSlot === 'P9_Mobile') {
                                    googletag.pubads().refresh([P9_Mobile]); 
                                } 

                                else if (adSlot === 'P10_Mobile') {
                                    googletag.pubads().refresh([P10_Mobile]); 
                                } 

                                else if (adSlot === 'In_Text_2_Mobile') {
                                    googletag.pubads().refresh([In_Text_2_Mobile]); 
                                } 

                                else if (adSlot === 'In_Text_3_Mobile') {
                                    googletag.pubads().refresh([In_Text_3_Mobile]); 
                                } 

                                else if (adSlot === 'In_Text_4_Mobile') {
                                    googletag.pubads().refresh([In_Text_4_Mobile]); 
                                } 

                                else if (adSlot === 'In_Text_5_Mobile') {
                                    googletag.pubads().refresh([In_Text_5_Mobile]); 
                                } 

                                else if (adSlot === 'In_Text_6_Mobile') {
                                    googletag.pubads().refresh([In_Text_6_Mobile]); 
                                } 

                                else if (adSlot === 'In_Text_7_Mobile') {
                                    googletag.pubads().refresh([In_Text_7_Mobile]); 
                                } 

                                else if (adSlot === 'In_Text_8_Mobile') {
                                    googletag.pubads().refresh([In_Text_8_Mobile]); 
                                } 

                                else if (adSlot === 'In_Text_9_Mobile') {
                                    googletag.pubads().refresh([In_Text_9_Mobile]); 
                                } 

                                else if (adSlot === 'In_Text_10_Mobile') {
                                    googletag.pubads().refresh([In_Text_10_Mobile]); 
                                } 

                                else if (adSlot === 'Under_Article_Mobile') {
                                    googletag.pubads().refresh([Under_Article_Mobile]); 
                                } 

                                else if (adSlot === 'In_Gallery_1_Mobile') {
                                    googletag.pubads().refresh([In_Gallery_1_Mobile]); 
                                } 

                                else if (adSlot === 'In_Gallery_2_Mobile') {
                                    googletag.pubads().refresh([In_Gallery_2_Mobile]); 
                                } 

                                else if (adSlot === 'In_Gallery_3_Mobile') {
                                    googletag.pubads().refresh([In_Gallery_3_Mobile]); 
                                } 

                                else if (adSlot === 'In_Gallery_4_Mobile') {
                                    googletag.pubads().refresh([In_Gallery_4_Mobile]); 
                                } 

                                else if (adSlot === 'In_Gallery_5_Mobile') {
                                    googletag.pubads().refresh([In_Gallery_5_Mobile]); 
                                } 

                            }

                        }
                    });
                });
                observer.unobserve(entry.target); // Stop observing the ad slot which has alredy been seen. 
            }
        })
    }, {rootMargin: DISTANCE_IN_PIXELS_FOR_LAZY_LOADING}); // Distance to the ad slot.

    document.querySelectorAll('.lazyAd').forEach(slots => { observer.observe(slots) }); // Check all divs with the class lazyAd and observe them all. 

    // Get the list of slots associated with this service for the refresh logic.
    var refreshVisibilityState = {};
    var refreshTimers = {};

    function clearRefreshTimer(slotId) {
        if (refreshTimers[slotId]) {
            clearTimeout(refreshTimers[slotId]);
            refreshTimers[slotId] = null;
        }
    }

    function scheduleSlotRefresh(slotAd) {
        var divId = slotAd.getSlotElementId();

        if (!refreshVisibilityState[divId] || refreshTimers[divId] || isNoRefreshSlot(slotAd)) {
            return;
        }

        refreshTimers[divId] = setTimeout(function() {
            refreshTimers[divId] = null;

            if (!refreshVisibilityState[divId] || document.visibilityState !== 'visible' || isNoRefreshSlot(slotAd)) {
                return;
            }

            var nextRefreshCount = getSlotRefreshCount(slotAd) + 1;
            slotAd.setTargeting('refresh_count', String(nextRefreshCount));
            slotAd.setTargeting('refresh_bucket', getRefreshBucket(nextRefreshCount));

            refreshSlotWithBestEffortPrebid(slotAd, divId, function() {
                if (refreshVisibilityState[divId] && document.visibilityState === 'visible' && !isNoRefreshSlot(slotAd)) {
                    scheduleSlotRefresh(slotAd);
                }
            });
        }, getRefreshDelaySeconds(divId) * 1000);
    }

    googletag.pubads().getSlots().forEach(function(slotAd) {
        var divId = slotAd.getSlotElementId();

        // Use IntersectionObserver API to check whether an ad slot is viewable for certain percent.
        var viewabilityObserver = new IntersectionObserver(function(viewabilityEntries) {
            viewabilityEntries.forEach(function(viewabilityEntry) {
                refreshVisibilityState[divId] = !!viewabilityEntry.isIntersecting;

                if (viewabilityEntry.isIntersecting) {
                    scheduleSlotRefresh(slotAd);
                } else {
                    clearRefreshTimer(divId);
                }
            });
        }, { threshold: VISIBILITY_PERCENT_FOR_REFRESH });

        document.querySelectorAll('#' + divId).forEach(function(viewabilitySlot) {
            viewabilityObserver.observe(viewabilitySlot);
        });
    });

    document.addEventListener('visibilitychange', function() {
        googletag.pubads().getSlots().forEach(function(slotAd) {
            var divId = slotAd.getSlotElementId();

            if (document.visibilityState === 'visible') {
                scheduleSlotRefresh(slotAd);
            } else {
                clearRefreshTimer(divId);
            }
        });
    });


}
